import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../hooks/useApi";

export default function AddUser() {
    const [username, setUserName] = useState("");
    const [useremail, setUserEmail] = useState("");
    const baseName = import.meta.env.VITE_APP_BASE_URL;

    const { apiCall } = useApi();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            const response = await apiCall(`user-add_user`, {
                method: "POST",
                body: {
                    user_email: useremail,

                },
            });
            const data = await response.json();
            if (!data.success) {
                throw new Error(data.error);
            }

            alert("User added successfully!");
            window.location.href = window.location.origin + baseName + `edit-user/${btoa(useremail)}`; // Reload the page to see the new user in the list
            //take to the edit page
        } catch (error) {
            console.error("Error adding the user:", error);
            alert(error);
        }
    }

    return (
        <div className="p-6">
            <div className="flex justify-between items-center mb-10">
                <h1 className="text-2xl font-bold">Add New User</h1>

                <Link to={`/users/`} className="btn btn-primary self-end">
                    Back
                </Link>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4 max-w-md">

                <input
                    type="email"
                    placeholder="User Email"
                    value={useremail}
                    onChange={(e) => setUserEmail(e.target.value)}
                    className="border p-2 rounded w-full"
                    required
                />

                <button type="submit" className="btn btn-primary">Add User</button>
                <Link to={`/users/`}>
                    <button type="button" className="btn btn-cancel ml-4">Cancel</button>
                </Link>
            </form>
        </div>
    );
};